export const workflowDesigner = {
  active: "Active",
  activeCondition: "Active Condition",
  advanced: "Advanced",
  backToOverview: "Back to overview",
  backToReporting: "Back to reporting",
  baseData: "Basic information",
  billingFrom: "Billing from",
  billingTo: "Billing to",
  childProcesses: "Child processes",
  className: "Class name",
  classNameHelp: "Unique technical name of the workflow, e.g. 'ArticleImport'.",
  classNameHint: "No white spaces or special characters allowed.",
  clipboard: "Clipboard",
  clipboardClear: "Clear clipboard",
  columnComments: "Comments",
  columnConfiguration: "Configuration",
  columnData: "Data",
  columnElements: "Elements",
  columnLogging: "Logging",
  columnParameters: "Parameters",
  columnWorkflow: "Workflow",
  comment: "Comment",
  contentIdentifier: "Content identifier",
  contentIdentifierHelp: "What does the content identifier represent? ",
  copyParameter: "Click here to copy the parameters",
  create: "Upload workflow",
  createDataStructureJsonError: "{name} do not contain a valid JSON",
  cropIcon: "Crop icon",
  cropLogo: "Crop graphic",
  collapseAll: "Open all",
  collapseNone: "Close all",
  dangerZone: "Danger zone",
  dangerZoneDeleteTitle: "Delete workflow",
  dangerZoneDeleteText:
    "Are you sure you want to delete the workflow '{workflow}'? This action can not be undone.",
  dangerZoneText:
    "You are in the danger area. All actions you take here are irrevocable. ",
  daysSelected: "Days selected",
  deleteWorkflow: "Delete workflow",
  deleteWorkflowSubtitle: "Deleting a workflow is irrevocable.",
  description: "Description",
  dependency: "Dependencies",
  designer: "Designer",
  designerProcess: "Designer process",
  edit: "Configure workflow",
  dontConsiderInBilling: "Don't consider in billing",
  dropAreaText: "Place a graphic here to upload ",
  dropError: "Element cannot be placed here",
  editGroup: "Edit group name",
  deleteGroup: "Delete group",
  deleteGroupTitle: "Delete workflow group",
  deleteGroupText:
    'Do you really want to workflow group "{title}"? This process is irreversible.',
  elementsApiGateway: "API-Gateway",
  elementsCommunication: "Communication",
  elementsHelper: "Helper",
  elementsConnector: "Connectors",
  elementsData: "Data saving",
  elementsMapping: "Mappings",
  elementsOperator: "Operators",
  elementsTrigger: "Triggers",
  elementsDataStructures: "Data Structures",
  elementsFiles: "Files",
  elementsReporting: "Reporting",
  elementsTransformer: "Transformer",
  elementsClipboard: "Clipboard",
  execute: "Execute",
  executeImmediately: "Execute workflow immediately",
  externallyTriggerable: "Externally triggerable",
  externallyTriggerableHelp:
    "Choose if workflow should be able to get triggered by public URL.",
  fromElement: "from Element {value}",
  fromJob: "from Job {value}",
  hidePreview: "Hide preview",
  icon: "Icon",
  jobs: "Jobs",
  label: "Label",
  logo: "Graphic",
  modeBuild: "Configuration",
  modeCode: "Code",
  modeDebug: "Debug",
  modePlanning: "Planning",
  name: "Label",
  newEditorOnly: "Only available in new editor",
  noChildProcesses: "This workflow has no child processes.",
  noClipboardElements: "No elements were copied to clipboard yet.",
  noElementsOfType: "There were no elements found for this type.",
  none: "None",
  noJobs: "No jobs executed",
  noProject: "Not assigned to a project",
  noSelectData: "No data available",
  openCode: "Open code editor",
  openDesigner: "Open designer",
  openJournal: "Open journal",
  openReporting: "Open reporting",
  parameter: "Parameter",
  parametersPreview: "Preview",

  jobStatusInfo: "Info",
  jobStatusStopped: "Job completed successfully ",
  jobStatusWarning: "Jobs partially successful ",
  jobStatusPending: "Job waiting for execution",
  jobStatusWorking: "Job is being executed",
  jobStatusAborted: "Job has been aborted",
  jobStatusError: "Job error",

  logStatusInfo: "Info",
  logStatusStopped: "Stopped ",
  logStatusWarning: "Warning ",
  logStatusPending: "Pending",
  logStatusWorking: "Working",
  logStatusAborted: "Aborted",
  logStatusError: "Error",

  projectChoose: "Choose project",
  properties: "Properties",
  operatorBranch: "Branch",
  operatorChange: "Change operator",
  operatorConnection: "Simple connection",
  queue: "Queue",
  queueChoose: "Choose queue",
  queueChooseHelp: "On which queue should the workflow be executed by default?",
  recipientEmail: "Recipient email",
  removeAll: "Remove all elements",
  removeIcon: "Remove icon" + "",
  removeLogo: "Remove graphic",
  reportingHeader: "Reporting workflow {workflow}",
  reportingHeaderDetail: "Logs job {jobId} workflow {workflow}",
  reset: "Reset",
  searchElements: "Search elements...",
  searchElementsNotFound: "There were no matching elements of this type found.",
  selectNextElement: "Next element",
  selectPlaceholder: "Select...",
  selectWidget: "Please select a widget from designer first.",
  setEndPoint: "Set end point",
  removeEndPoint: "Remove end point",
  setParameters: "Set parameters",
  saveAndTest: "Save and test",
  share: "Share",
  shared: "Workflow shared!",
  showParameter: "Show parameter",
  startProcessFirst: "Start workflow to show logs.",
  tabCode: "Code",
  tabCodePhp: "PHP code",
  tabStructure: "Structure",
  tabStructureYaml: "YAML structure",
  tabVisual: "Visual",
  testWorkflowTableTitle: "Latest jobs with parameters",
  testWorkflowTableDescription:
    "Insert the parameters with which the workflow is to be started here.",
  timeTooltip:
    "Use the format <b>2d 5h 30m</b><ul>\n" +
    "  <li>d = days</li>\n" +
    "  <li>h = hours (0-23)</li>\n" +
    "  <li>m = minutes (0-59)</li>\n" +
    "</ul>",
  token: "Token",
  tokenHelp:
    "With the help of one or more tokens, a unique URL can be generated via which the owner can be authenticated by the system and thus start the workflow.",
  trigger: "Trigger",
  triggerChoose: "Choose trigger",
  triggerChooseHelp:
    "In which interval should the workflow start automatically?",
  triggerConfig: "Configure trigger",
  uploadIcon: "Upload icon",
  uploadLogo: "Upload graphic",
  triggerDisabledText: "This workflow is triggered by a preceding workflow.",
  type: "Dataset-type",
  typeHelp: "What type is the data record processed in the workflow?",
  workflowCancel: "Cancel jobs",
  workflow: "Workflow",
  workflowCreate: "Create Workflow",
  workflowGroupCreate: "Create Workflow group",
  workflowImportHelp: "Import Workflow",
  workflowExportAs: "Export Workflow as",
  workflowExport: "Export",
  workflowExportTitle: "Export Workflow",
  workflowImportSuccess:
    "Workflow was successfully imported. However, the workflow still needs to be configured",
  workflowImportError: "There was an error importing the workflow",
  workflowExportSuccess: "Successfully exported Workflow: '{name}'",
  workflowExportError: "There was an error exporting the workflow",
  workflowDesigner: "Workflow designer",
  workflowDesignerTable: "Workflow overview",
  workflowSaved: "Workflow saved!",
  workflowStart: "Start workflow",
  workflowStarted: "Workflow started",
  workflowTest: "Test workflow",
  workflowChoose: "Previous workflow",
  clearDesignerTitle: "Remove all elements",
  clearDesignerText:
    "By confirming this action, every element in this workflow will be removed. This process can only be reset, until the workflow gets saved the next time.",
  toggleCriticalPath: "Show/hide critical path",
  toggleMap: "Show/hide minimap",
  toggleGrid: "Show/hide grid",
  toggleFullscreen: "Enable/disable fullscreen",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  saveAsImage: "Save as image",
  clearWorkflow: "Remove all elements",
  inactive: "inactive",
  queueLow: "Low",
  queueHigh: "High",
  queueNone: "None",
  selectElement: "Select workflow element...",
  configureElement: "Configure {label}",
  showGitHistory: "Show git history",
  gitHistory: "Git History",
  modeHistory: "Git History",
  revertToThisChange: "Revert to this change",
  areYouSureYouWantToRevert: "Are you sure you want to revert ?",
  revert: "Revert",
  input: "Input parameter",
  output: "Output parameter",
  noDebugData: "No debug data",
  contactPerson: "Responsible Developer",
  validationError: "Validation error",
  queueSignal: "Warning: Queue-Interruption",
  queueSignalInfoText:
    "The processing of the queue was interrupted. As soon as all currently running processes have been processed, the queue workers are restarted and further jobs are processed again.",
  queueCurrentProcesses: "Currently running processes:",
  queueWarning: "Queue-Interruption",
  emailRecipient: "Recipient E-Mail",
  emailNotSending: "no mailing",
  emailOnlyErrors: "only errors",
  emailOnlyWarnings: "only warnings",
  emailWarningsErrors: "errors and warnings",
  centerView: "Center view",
  unsavedChangesTitle: "Unsaved changes detected!",
  unsavedChangesText:
    "Unsaved changes have been detected. These will be irrevocably lost. Do you still want to continue?",
  discardChanges: "Discard changes",
  option: {
    planning: "Planning",
    authentication: "Authentication",
    configuration: "Configuration",
    input: "Input",
    output: "Output",
    error: "Error handling",
    documentation: "Documentation"
  },
  componentLibrary: {
    close: "Close component library",
    open: "Open component library"
  },
  debugView: {
    close: "Close debug view",
    open: "Open debug view"
  },
  openMapping: "Open Mapping",
  openDataSet: "Open DataSet",
  openTextTemplate: "Open TextTemplate",
  openAssignmentTable: "Open Assignment",
  openDataStructure: "Open DataStructure",
  openPhpEditor: "Open PHP-Editor",
  openWorkflow: "Open Workflow",
  openFileExplorer: "Open File Explorer",
  xMoreProcesses: " and {number} more",
  sendEmailOn: "Send email on",
  createNewWorkflow: "Start now by creating your first workflow!",
  createNewQueue:
    "To create a workflow, you must first create a queue. Click here to create a new queue.",
  status: "Status",
  from: "From",
  to: "To",
  requeue: "Requeue jobs",
  selectStatus: "Select status",
  triggerChildProcesses: "Trigger child processes",
  managedByProcessEngine: "Xentral Flows",
  eventAlert:
    "It takes up to 30 minutes for the first events to arrive in the workflow!",
  generateFlowDescription: "Generate Flow description",
  category: "Select categories",
  limitReached: "Limit reached. You cannot add any more Workflows.",
  usage: "{usage} / {limit} Workflows",
  elementsUsage: "{usage} / {limit} Elements",
  elementsLimitInfo:
    "Your current plan includes up to {limit} components per flow ({used} used).",
  isTemplate: "Template"
};
